module.exports = require("@swa-ui/placements/src/HeroImagePlacement/HeroImagePlacement.module.scss");